import React from 'react';
import { AvailabilityStatusLabel } from '@/components/availability-status-label';
import { BadgeLabelList } from '@/components/orders/badge-label-list';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { PackUnit, VariantPackAvailabilityStatus } from '@/enums';
import { Text, View } from 'react-native';
import { useShouldRenderAvailabilityStatusLabel } from '@/hooks/use-add-to-order-disabled';
import { VariantPackInfoContext_GroupBadgeFieldsFragment } from '@/types';

interface Props {
  availabilityStatus: VariantPackAvailabilityStatus | null;
  availableQuantity: number | null;
  badges?: VariantPackInfoContext_GroupBadgeFieldsFragment[];
  displayName: string;
  externalID?: string | null;
  packUnit?: PackUnit | null;
}

export const SalesRepVariantPackDetails: React.FC<Props> = ({
  availableQuantity,
  availabilityStatus,
  badges,
  displayName,
  externalID,
  packUnit,
}) => {
  const [styles] = useStyles();
  const shouldRenderAvailabilityStatusLabel =
    useShouldRenderAvailabilityStatusLabel({
      availabilityStatus,
      availableQuantity,
    });

  return (
    <View style={styles.variantPackDetails}>
      <Text
        numberOfLines={1}
        style={[TYPOGRAPHY.listTitle, FONTS.primarySemiBold]}
      >
        {displayName}
      </Text>
      <Text
        numberOfLines={1}
        style={[FONTS.primary, TYPOGRAPHY.small, styles.packUnit]}
      >
        {externalID}
        {externalID && packUnit ? ' • ' : null}
        {packUnit}
      </Text>
      <BadgeLabelList
        badges={badges}
        footer={
          shouldRenderAvailabilityStatusLabel ? (
            <AvailabilityStatusLabel
              availabilityStatus={availabilityStatus}
              containerStyle={styles.statusLabel}
            />
          ) : null
        }
      />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  packUnit: {
    color: theme.sk.color.text.tertiary,
    textTransform: 'capitalize',
  },
  statusLabel: {
    alignSelf: 'flex-start',
  },
  variantPackDetails: {
    flex: 1,
    marginHorizontal: 16,
  },
}));
